import { render } from "./ShopCafeProgress.vue?vue&type=template&id=10a28272"
import script from "./ShopCafeProgress.vue?vue&type=script&lang=js"
export * from "./ShopCafeProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__